export default "__VITE_ASSET__a5008317__"